run.$inject = ['$rootScope', '$templateCache', '$state', '$stateParams', '$timeout', 'MenuConstant', 'workplan', 'GlobalConfig', 'WorkPlanModalSrv', 'WorkPlanSrv']

export default function run ($rootScope, $templateCache, $state, $stateParams, $timeout, MenuConstant, workplan, GlobalConfig, WorkPlanModalSrv, WorkPlanSrv) {
  $templateCache.put('projects-list', require('../research/projects/list/project-list.html'))
  $templateCache.put('project-details', require('../research/projects/list/project-details.html'))
  $templateCache.put('list-data-project', require('../research/projects/list/jobs/list-data-project.html'))
  $templateCache.put('details-header-project', require('../research/projects/list/details/details-header-project.html'))
  $templateCache.put('header-project', require('../research/projects/list/header-project.html'))
  $templateCache.put('customStyle', require('../research/customStyle.html'))

	$templateCache.put('products-list', require('../research/products/list/products-list.html'))
  $templateCache.put('products-details', require('../research/products/list/products-details.html'))
  $templateCache.put('list-data-products', require('../research/products/list/jobs/list-data-products.html'))
  $templateCache.put('details-header-products', require('../research/products/list/details/details-header-products.html'))
  $templateCache.put('header-products', require('../research/products/list/header-products.html'))  
}




// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/research/research.run.js